import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { environment } from './environments/environment';

Sentry.init({
  dsn: environment.sentryDsn || undefined,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  environment: environment.sentryEnvironment || undefined,
  sampleRate: 0.2,
  tracesSampleRate: 0.2,
  profilesSampleRate: 0.2,
});
